"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = exports.SmallSpinner = exports.PageSpinner = exports.NextSpinner = void 0;
var _react = _interopRequireDefault(require("react"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
var Spinner = exports.Spinner = function Spinner(_ref) {
  var additionalStyle = _ref.additionalStyle;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('spinner', additionalStyle)
  });
};
var PageSpinner = exports.PageSpinner = function PageSpinner(_ref2) {
  var additionalStyle = _ref2.additionalStyle,
    className = _ref2.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('spinner-container page-spinner', className)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('spinner', additionalStyle)
  }));
};
var SmallSpinner = exports.SmallSpinner = function SmallSpinner(_ref3) {
  var show = _ref3.show,
    color = _ref3.color,
    additionalStyle = _ref3.additionalStyle;
  var spinnerColor = color ? color : 'initial';
  var spinnerStyle = (0, _merge.default)({
    opacity: show ? 1 : 0,
    borderLeftColor: spinnerColor,
    borderTopColor: spinnerColor,
    borderBottomColor: spinnerColor
  }, additionalStyle);
  return /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "spinner-small",
    style: spinnerStyle,
    className: "spinner-small"
  });
};
var NextSpinner = exports.NextSpinner = function NextSpinner(_ref4) {
  _objectDestructuringEmpty(_ref4);
  return /*#__PURE__*/_react.default.createElement("div", {
    class: "d-flex justify-content-center align-items-center h-100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "spinner-border",
    role: "status"
  }, /*#__PURE__*/_react.default.createElement("span", {
    class: "sr-only"
  }, "Loading...")));
};